import _ from 'lodash';
import L from 'react-loadable';

import Loading from '../components/Loading';

const defaultConfig = { timeout: 10000, loading: Loading };

const Loadable = (loader) => L(_.assign({}, defaultConfig, { loader }))

export default Loadable;